export enum GameResultTypeEnum {
  Win = "Win",
  Loss = "Loss",
  Draw = "Draw",
  Null = "Null",
}
